import { type JanusCtx, activeStatuses, ecId, handBack, insertRoll, type Row } from '../context.js';
import { SHIELDED_IDS, shieldedChanges } from '../../statuses/shielded.js';
import { statusItemId } from '../../statuses/expiry.js';
import { removeStoredStatus } from './status-effect-removal-helpers.js';

export function consumeShielded(ctx: JanusCtx, caster: Row, target: Row): void {
  const changes = shieldedChanges({ ...target, statuses: { target: activeStatuses(ctx, target) } });
  if (!changes.length) return;
  if (!ecId(target)) handBack('damage:shielded-inventory-out-of-scope');
  if (!ctx.statusStacks) handBack('damage:shielded-stack-writer-unavailable');
  for (const change of changes) {
    const row = activeStatuses(ctx, target).find(s => SHIELDED_IDS.has(statusItemId(s)) && String(s.status_id ?? '').toUpperCase() === change.status_id)!;
    const added = ctx.statusesAdded.find(s => s === row as unknown);
    if (added) {
      if (added.status_stack > 1) {
        added.status_stack--;
        insertRoll(ctx, { roll_type_1: 'status_stack_decreased', roll_item_id: change.status_item_id, by: caster, to: target });
      } else removeStoredStatus(ctx, target, row);
      continue;
    }
    const pending = ctx.statusStacks!.find(s => s.status_id === change.status_id);
    const current = pending?.status_stack ?? change.before;
    if (current > 1) {
      if (pending) pending.status_stack--;
      else ctx.statusStacks!.push({ ...change, target: ecId(target), status_stack: current - 1 });
      insertRoll(ctx, { roll_type_1: 'status_stack_decreased', roll_item_id: change.status_item_id, by: caster, to: target });
    } else {
      if (pending) ctx.statusStacks!.splice(ctx.statusStacks!.indexOf(pending), 1);
      removeStoredStatus(ctx, target, row);
    }
  }
}
